import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const ConfirmationDialog = ({ open, onClose, onConfirm, title, message, confirmText }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        zIndex: 1000001,
        '& .MuiBackdrop-root': {
          zIndex: 1000000,
        },
        '& .MuiPaper-root': {
          position: 'relative',
          zIndex: 1000001,
          fontSize: '10.5px',
        },
        '& .MuiTypography-root': {
          fontSize: '10.5px',
        },
        '& .MuiDialogTitle-root': {
          fontSize: '10.5px',
          fontWeight: 600,
        },
        '& .MuiDialogContentText-root': {
          fontSize: '10.5px',
        },
        '& .MuiButton-root': {
          fontSize: '10.5px',
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button cla onClick={onClose} color="black" sx={{border: 0.5}}>
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button onClick={onConfirm} color="primary" sx={{ backgroundColor: '#EF4444', 'color':'white'} }>
          {confirmText || t('common.confirm', 'Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
